import React from 'react'
import MoneyExConverter from './3.forms and hooks/Assignment-3(Money Exchange)/MoneyExConverter'
// import Notes from './Assignment-2/Notes'
// import Converter from './3.forms and hooks/Assignment-2(Crypto Converter)/Converter'
function App() {

  return (
    <div>
      {/* <Notes /> */}
      {/* <Converter /> */}
      <MoneyExConverter />
    </div>
  )
}

export default App